import React from 'react';
import { motion } from 'framer-motion';
export function Gallery() {
  const photos = ['https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1581092335397-9583eb92d232?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1581091226033-d5c48150dbaa?auto=format&fit=crop&q=80&w=600', 'https://images.unsplash.com/photo-1581092162384-8987c1d64718?auto=format&fit=crop&q=80&w=600'];
  return <div className="bg-[#FAF9F7] min-h-screen pb-24" data-id="element-328">
      <div className="bg-[#4A0000] py-16 text-center" data-id="element-329">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-4xl md:text-5xl font-bold text-white font-serif" data-id="element-330">
          Gallery
        </motion.h1>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-16" data-id="element-331">
        <div className="flex items-center gap-4 mb-12" data-id="element-332">
          <div className="h-px bg-gray-300 flex-grow" data-id="element-333"></div>
          <h2 className="text-3xl font-bold text-gray-900 font-serif" data-id="element-334">
            Photo Gallery
          </h2>
          <div className="h-px bg-gray-300 flex-grow" data-id="element-335"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-336">
          {photos.map((photo, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="aspect-square rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-shadow cursor-pointer group" data-id="element-337">
              <img src={photo} alt={`Gallery ${index}`} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-338" />
            </motion.div>)}
        </div>
      </div>
    </div>;
}